<template>
  <div v-if="quoteSummary != null" class="modal-content select-none">
    <div class="modal-body !p-[15px] font-roboto">
      <!-- Figma UQ "Quote Summary - Popup": shared modal header band + red X -->
      <FxModalHeader title="Quote Summary" @close="closeModal" />
      <div class="flex flex-col gap-1 px-[10px] tablet:px-0">
        <div class="flex items-center justify-between pb-2.5">
          <h3 class="m-0 text-[16px] font-roboto font-medium text-[#333333]">
            Items Added
          </h3>
          <h2 class="m-0 text-[30px] tablet:text-[32px] laptop:text-[36px] font-roboto font-semibold text-[#BA90C6]">
            ${{ $helper.formatAmountMode(quoteSummary.item_total, 1) }}.{{
              $helper.formatAmountMode(quoteSummary.item_total, 2) }}
          </h2>
        </div>
        <div v-if="quoteSummary.items.length > 0" class="!pe-1 max-h-[50vh] overflow-y-auto overflow-hidden">
          <ul class="p-0 m-0 flex flex-col gap-2">
            <li v-for="(item, index) in quoteSummary.items[0].data" :key="index"
              class="flex items-center justify-between border-1 p-2 rounded-[5px] bg-opacity-50 bg-[#EFEFEF] border-[#EFEFEF]">
              <span class="text-[14px] font-medium leading-[1.2] font-roboto text-[#666666]">{{ item.option }}:
                <p v-if="item.sub_text?.length > 0" class="m-0 text-[12px] font-medium font-roboto text-[#168EFF]">({{
                  item.sub_text
                }})
                </p>
              </span>
              <span v-if="item.total_cost < 0" class="text-[18px] tablet:text-[20px] font-roboto font-medium text-[#333333]">
                $({{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{
                  $helper.formatAmountMode(item.total_cost, 2)
                }}</span>)
              </span>
              <span v-else class="text-[18px] tablet:text-[20px] font-roboto font-medium text-[#333333]">
                ${{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{
                  $helper.formatAmountMode(item.total_cost, 2)
                }}</span>
              </span>
            </li>
          </ul>
          <div v-if="quoteSummary.items.length > 2">
            <div v-for="(item, index) in quoteSummary.items[2].data" :key="index"
              class="flex items-center justify-between mt-2 border-1 p-2 rounded-[5px] bg-[#fff] border-[#EFEFEF]">
              <span v-if="quoteDetail.partner_info.is_allied" class="text-[14px] font-roboto text-[#333333]">
                {{ quoteSummary.items[2].data[0].option }}
              </span>
              <span v-else class="text-[14px] font-roboto text-[#333333]">
                {{ quoteSummary.items[2].heading }}
              </span>
              <h2 v-if="item.total_cost < 0" class="m-0 text-[18px] tablet:text-[20px] font-roboto font-medium text-[#EA8A8A]">
                $({{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{
                  $helper.formatAmountMode(item.total_cost,
                    2)
                }}</span>)
              </h2>
              <h2 v-else class="m-0 text-[18px] tablet:text-[20px] font-roboto font-medium text-[#EA8A8A]">
                ${{ $helper.formatAmountMode(item.total_cost, 1) }}.<span class="text-[14px]">{{
                  $helper.formatAmountMode(item.total_cost,
                    2)
                }}</span>
              </h2>
            </div>
          </div>
          <div v-if="quoteSummary.items.length > 1">
            <div v-for="(item, index) in quoteSummary.items[1].data" :key="index"
              class="flex items-center justify-between border-1 p-2 mt-2 rounded-[5px] bg-[#fff] border-[#EFEFEF]">
              <span v-if="quoteDetail.partner_info.company_name.toLowerCase() == 'vivint'"
                class="text-[14px] font-roboto text-[#333333]">
                Vivint Coverage
              </span>
              <span v-if="quoteDetail.partner_info.is_allied"
                class="max-w-[70%] text-[14px] font-medium font-roboto text-[#333333]">
                {{ quoteSummary.items[1].data[0].option }}
              </span>
              <span v-else class="max-w-[70%] text-[14px] font-medium font-roboto text-[#333333]">
                {{ quoteSummary.items[1].heading }}
              </span>
              <h2 v-if="item.total_cost < 0" class="m-0 text-[18px] tablet:text-[20px] font-roboto font-medium text-[#EA8A8A]">
                $({{ $helper.formatAmountMode(item.total_cost, 1) }}.{{
                  $helper.formatAmountMode(item.total_cost,
                    2)
                }})
              </h2>
              <h2 v-else class="m-0 text-[18px] tablet:text-[20px] font-roboto font-medium text-[#EA8A8A]">
                ${{ $helper.formatAmountMode(item.total_cost, 1) }}.{{
                  $helper.formatAmountMode(item.total_cost,
                    2)
                }}
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-end mt-2.5">
          <h3 class="m-0 text-[18px] tablet:text-[20px] font-roboto text-[#BA90C6]">
            Quote Total
          </h3>
          <h2 class="m-0 text-[30px] tablet:text-[32px] laptop:text-[36px] font-roboto font-bold text-[#333333]">
            ${{ $helper.formatAmountMode(quoteSummary.total, 1) }}.{{
              $helper.formatAmountMode(quoteSummary.total, 2)
            }}
          </h2>
        </div>
      </div>
    </div>
    <div v-if="$route.name == 'QuoteEdit'" class="modal-footer !py-[20px] !justify-center">
      <button type="button" @click="submitQuote()"
        class="px-[32px] py-[8px] rounded-[5px] text-[14px] font-roboto font-medium transition duration-300 border-[#00B7C2] border-1 mobile:bg-[#00B7C2] laptop:bg-[#fff] mobile:text-[#fff] laptop:text-[#00B7C2] laptop:hover:bg-[#00B7C2] laptop:hover:text-[#fff]">
        Submit Quote
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { enableScroll } from "../../helpers/scrollHelper";
import FxModalHeader from "../nest_components/FxModalHeader.vue";
export default {
  components: { FxModalHeader },
  props: ["quoteSummary", "readOnly"],

  data() {
    return {
      onConfirm: {},

    };
  },
  computed: {
    ...mapGetters(["quoteDetail"]),
  },
  watch: {},
  mounted() { },
  methods: {
    ...mapActions(["setCommponent", "postQuoteSummary"]),
    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },
    closeModal() {
      enableScroll()
      this.$emit("event", "close");
    },
    submitQuote() {
      enableScroll()
      this.$emit("event", "submit");
    },
  },
};
</script>
